
<div class="container justify-content-md-center">
  <div class="row">
    <div class="col mt-5 text-center about-info">
      <h2>Oops</h2>
    </div>
  </div>
  <div class="row">
    <div class="col text-center">
      <img src="../../../assets/images/specman-oops.png" class="mx-auto d-block" alt="...">
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col-md-8 mt-3">
      <h4>The requested page does not exist</h4>
      <p>Please check the URL and try again or visit <a [routerLink]="['/support']"
          routerLinkActive="router-link-active">our support team</a> for more information</p>
    </div>
  </div>
</div>
